export const MFA_REQUIRED_CODE = "MFA_REQUIRED";

export const MFA_REQUIRED_HEADER = "x-remi-mfa-required";

export const MFA_EXEMPT_PATHS = ["/mfa/setup", "/sign-in", "/sign-up"] as const;
